<template>
  <div class="map-poi overflow-hidden" :class="{ 'is-retina-map': isRetina }">
    <div ref="mapEl" class="map-root" />
    <div class="hidden">
      <div ref="popup">
        <slot />
      </div>
    </div>
    <MapsTrackingPixel />
  </div>
</template>

<script lang="ts" setup>
import '~/assets/css/dynamic/map.css'
import L from 'leaflet'

const props = defineProps<{
  location: [number, number]
  title: string
}>()

defineEmits(['close'])

const mapEl = ref<HTMLDivElement>()

const { isRetina } = useMap(mapEl, {
  init: (map) => {
    const icon = L.divIcon({
      className: 'map-poi-marker',
      iconSize: L.point(24, 24),
    })

    const marker = L.marker(props.location, { icon }).addTo(map)
    if (props.title) {
      marker.bindTooltip(props.title, {
        direction: 'top',
        opacity: 1,
        offset: [0, -16],
        permanent: true,
      })
    }

    map.setView(props.location, 13)
  },
})
</script>
